import React from "react";
import { Rows, SquaresFour } from "@phosphor-icons/react";

/**
 * Persisted card/list toggle.
 * Usage:
 *   const [view, setView] = useViewMode("formulas", "list");
 *   <ViewToggle value={view} onChange={setView} />
 */
export function useViewMode(key, defaultValue = "list") {
    const storageKey = `dq_view_${key}`;
    const [v, setV] = React.useState(() => {
        try { return localStorage.getItem(storageKey) || defaultValue; } catch { return defaultValue; }
    });
    const set = (next) => {
        setV(next);
        try { localStorage.setItem(storageKey, next); } catch {}
    };
    return [v, set];
}

export default function ViewToggle({ value, onChange, testid = "view-toggle" }) {
    return (
        <div className="border hairline bg-white inline-flex" data-testid={testid}>
            <button
                type="button"
                onClick={() => onChange("list")}
                className={`px-3 py-2 text-xs inline-flex items-center gap-1.5 ${value === "list" ? "bg-[var(--ink)] text-[var(--bone)]" : "text-[var(--ink-2)] hover:bg-[var(--cream)]"}`}
                data-testid={`${testid}-list`}
                aria-label="Vista lista"
            ><Rows size={12}/> Lista</button>
            <button
                type="button"
                onClick={() => onChange("cards")}
                className={`px-3 py-2 text-xs inline-flex items-center gap-1.5 ${value === "cards" ? "bg-[var(--ink)] text-[var(--bone)]" : "text-[var(--ink-2)] hover:bg-[var(--cream)]"}`}
                data-testid={`${testid}-cards`}
                aria-label="Vista cards"
            ><SquaresFour size={12}/> Cards</button>
        </div>
    );
}
